// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"cb1c4460","230":"b306139f","316":"2ab2dfff","454":"5640f6c0","479":"c581bea8","703":"fe7be2c6"}[chunkId] + ".chunk.js";
};